import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import { StatementType, UserDetailsType } from "../types/genericType";

export const getUserDetails = async (
  userId: number
): Promise<UserDetailsType> => {
  try {
    const response: AxiosResponse<UserDetailsType> = await axiosInstance.get(
      `${apiEndPoints.users}/${userId}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getAllUsers = async (): Promise<UserDetailsType[]> => {
  try {
    const response: AxiosResponse<UserDetailsType[]> =
      await axiosInstance.get(apiEndPoints.users);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createUser = async (
  firstName: string,
  lastName: string,
  email: string,
  accounts: string[] | null,
  statements: StatementType[] | null,
  role: number
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post(
      `${apiEndPoints.users}`,
      {
        firstName,
        lastName,
        email,
        accounts,
        statements,
        role,
        isActive: true,
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const editUser = async (
  id: number,
  firstName: string,
  lastName: string,
  email: string,
  accounts: string[] | null,
  statements: StatementType[] | null,
  isActive: boolean
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.put(
      `${apiEndPoints.users}/${id}`,
      {
        id,
        firstName,
        lastName,
        email,
        accounts,
        statements,
        isActive
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};